// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hero[data-v-1a4a7282]{position:relative;display:grid;justify-items:center;text-align:center;padding:1rem;z-index:1}@media(min-width: 62em){.hero[data-v-1a4a7282]{margin-top:3rem}}img[data-v-1a4a7282]{max-height:9.375rem}@media(min-width: 48em){img[data-v-1a4a7282]{max-height:18.75rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
